/* Taabib search bar: rotating placeholder, full-screen search panel, recent searches, live Shopify predictive search. */
(function () {
  if (window.customElements.get('taabib-search')) return;

  var ICON_TREND = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 17l6-6 4 4 8-8"/><path d="M15 7h6v6"/></svg>';
  var ICON_CLOCK = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>';
  var ICON_SEARCH = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M20 20l-3.5-3.5"/></svg>';
  var ICON_GRID = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><rect x="4" y="4" width="7" height="7" rx="1.5"/><rect x="13" y="4" width="7" height="7" rx="1.5"/><rect x="4" y="13" width="7" height="7" rx="1.5"/><rect x="13" y="13" width="7" height="7" rx="1.5"/></svg>';
  var ICON_CHEV = '<svg class="tbs-chev" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>';
  var RECENT_KEY = 'taabib_recent_searches';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function escRe(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
  /** Bold/highlight each typed word inside text (safe: escapes first). */
  function highlight(text, query, tag) {
    var safe = esc(text);
    var words = query.trim().split(/\s+/).filter(function (w) { return w.length > 1; }).map(function (w) { return escRe(esc(w)); });
    if (!words.length) return safe;
    return safe.replace(new RegExp('(' + words.join('|') + ')', 'gi'), '<' + tag + '>$1</' + tag + '>');
  }
  function readRecent() {
    try { var v = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); return Array.isArray(v) ? v.slice(0, 6) : []; } catch (e) { return []; }
  }
  function saveRecent(q) {
    q = String(q || '').trim(); if (q.length < 2) return;
    try {
      var list = readRecent().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
      list.unshift(q); localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, 6)));
    } catch (e) { /* storage blocked: ignore */ }
  }
  function clearRecent() { try { localStorage.removeItem(RECENT_KEY); } catch (e) { /* ignore */ } }

  class TaabibSearch extends HTMLElement {
    connectedCallback() {
      if (this._bound) {
        // Re-attached (e.g. in the theme editor): just put the panel back on <body>.
        if (this.panel.parentNode !== document.body) document.body.appendChild(this.panel);
        this.startRotator();
        return;
      }
      this._bound = true;
      this.trigger = this.querySelector('.tbs-trigger');
      this.panel = this.querySelector('.tbs-panel');
      var p = this.panel;
      this.form = p.querySelector('.tbs-bar');
      this.input = p.querySelector('.tbs-input');
      this.clearBtn = p.querySelector('.tbs-clear');
      this.idle = p.querySelector('.tbs-idle');
      this.live = p.querySelector('.tbs-live');
      this.status = p.querySelector('.tbs-status');
      this.recentBlock = p.querySelector('.tbs-recent');
      this.closeBtns = p.querySelectorAll('[data-tbs-close]');
      this.cache = {};
      this.timer = null;
      this.ctrl = null;
      this.isOpen = false;
      this.money = (this.dataset.moneyFormat || 'Rs.{{amount}}').replace(/<[^>]*>/g, '');
      this.root = (this.dataset.root || '/').replace(/\/?$/, '/');
      this.rxTag = (this.dataset.rxTag || '').toLowerCase();
      this.limit = Math.min(10, parseInt(this.dataset.limit, 10) || 8);

      // Move the panel to <body> so a theme header with overflow/transform can't clip the full-screen view.
      if (this.panel.parentNode !== document.body) document.body.appendChild(this.panel);

      this.startRotator();
      this.trigger.addEventListener('click', () => this.open());
      Array.prototype.forEach.call(this.closeBtns, (b) => b.addEventListener('click', () => this.close()));
      this.input.addEventListener('input', () => this.onInput());
      this.input.addEventListener('keydown', (e) => this.onKey(e));
      this.clearBtn.addEventListener('click', () => { this.input.value = ''; this.onInput(); this.input.focus(); });
      this.form.addEventListener('submit', (e) => {
        var q = this.input.value.trim();
        if (!q) { e.preventDefault(); return; }
        saveRecent(q);
      });
      this.panel.addEventListener('click', (e) => {
        var term = e.target.closest('[data-term]');
        if (term) { e.preventDefault(); this.input.value = term.getAttribute('data-term'); this.onInput(true); this.input.focus(); return; }
        if (e.target.closest('[data-clear-recent]')) { clearRecent(); this.renderRecent(); return; }
        var link = e.target.closest('a[href]');
        if (link && this.input.value.trim()) saveRecent(this.input.value);
        if (e.target === this.panel) this.close(); // backdrop on desktop
      });
      this.onPop = () => { if (this.isOpen) this.close(true); };
      window.addEventListener('popstate', this.onPop);
      this.panel.addEventListener('keydown', (e) => this.trapFocus(e));
    }

    disconnectedCallback() {
      clearInterval(this.rotTimer);
      this.rotTimer = null;
      if (this.isOpen) { this.isOpen = false; this.panel.hidden = true; document.documentElement.classList.remove('tbs-lock'); }
      // Take the panel back inside the element so it travels (or disappears) with it.
      if (this.panel && this.panel.parentNode === document.body) this.appendChild(this.panel);
    }

    /* ---------- rotating placeholder ---------- */
    startRotator() {
      var track = this.querySelector('.tbs-rotator__track');
      if (!track || this.rotTimer) return;
      if (!track.dataset.words) track.dataset.words = track.children.length;
      var words = Number(track.dataset.words);
      if (words < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      // Clone the first word at the end so the loop scrolls seamlessly.
      if (track.children.length === words) track.appendChild(track.children[0].cloneNode(true));
      var i = 0;
      this.rotTimer = setInterval(() => {
        if (this.isOpen || document.hidden) return;
        i++;
        track.style.transition = '';
        track.style.transform = 'translateY(' + (-1.4 * i) + 'em)';
        if (i === words) {
          setTimeout(() => { track.style.transition = 'none'; track.style.transform = 'translateY(0)'; i = 0; }, 500);
        }
      }, 2400);
    }

    /* ---------- open / close ---------- */
    open() {
      if (this.isOpen) return;
      this.isOpen = true;
      this.lastFocus = document.activeElement;
      this.panel.hidden = false;
      document.documentElement.classList.add('tbs-lock');
      this.trigger.setAttribute('aria-expanded', 'true');
      this.renderRecent();
      this.input.focus(); // inside the tap handler so the phone keyboard opens
      try { history.pushState({ taabibSearch: true }, ''); this.pushed = true; } catch (e) { this.pushed = false; }
      if (this.input.value.trim()) this.onInput(true);
    }

    close(fromHistory) {
      if (!this.isOpen) return;
      this.isOpen = false;
      this.panel.hidden = true;
      document.documentElement.classList.remove('tbs-lock');
      this.trigger.setAttribute('aria-expanded', 'false');
      if (this.pushed && !fromHistory) { this.pushed = false; history.back(); }
      this.pushed = false;
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
    }

    onKey(e) {
      if (e.key === 'Escape') { e.preventDefault(); this.close(); }
      if (e.key === 'ArrowDown') {
        var first = this.panel.querySelector('.tbs-body a, .tbs-body button');
        if (first) { e.preventDefault(); first.focus(); }
      }
    }

    trapFocus(e) {
      if (e.key === 'Escape') { this.close(); return; }
      if (e.key !== 'Tab') return;
      var f = Array.prototype.filter.call(this.panel.querySelectorAll('a[href], button:not([disabled]), input'), function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }

    /* ---------- recent searches ---------- */
    renderRecent() {
      if (!this.recentBlock) return;
      var list = readRecent();
      this.recentBlock.hidden = !list.length;
      var ul = this.recentBlock.querySelector('.tbs-chips');
      ul.innerHTML = list.map(function (q) {
        return '<li><button type="button" class="tbs-chip" data-term="' + esc(q) + '">' + ICON_CLOCK + esc(q) + '</button></li>';
      }).join('');
    }

    /* ---------- live search ---------- */
    onInput(immediate) {
      var q = this.input.value.trim();
      this.clearBtn.hidden = !this.input.value;
      clearTimeout(this.timer);
      if (q.length < 2) {
        if (this.ctrl) this.ctrl.abort();
        this.live.hidden = true; this.idle.hidden = false; this.status.textContent = '';
        return;
      }
      this.idle.hidden = true; this.live.hidden = false;
      if (this.cache[q.toLowerCase()]) { this.renderResults(q, this.cache[q.toLowerCase()]); return; }
      this.renderSkeleton();
      this.timer = setTimeout(() => this.fetchResults(q), immediate ? 0 : 220);
    }

    fetchResults(q) {
      if (this.ctrl) this.ctrl.abort();
      this.ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var url = this.root + 'search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=query,product,collection&resources[limit]=' + this.limit +
        '&resources[limit_scope]=each&resources[options][unavailable_products]=last';
      fetch(url, { signal: this.ctrl ? this.ctrl.signal : undefined, headers: { accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then((data) => {
          var res = (data && data.resources && data.resources.results) || {};
          this.cache[q.toLowerCase()] = res;
          if (this.input.value.trim() === q) this.renderResults(q, res);
        })
        .catch((err) => {
          if (err && err.name === 'AbortError') return;
          if (this.input.value.trim() === q) this.renderError(q);
        });
    }

    /** Formats a decimal price ("31.00") with the store's money format, e.g. "Rs.{{amount}}" -> "Rs.31.00". */
    formatMoney(v) {
      var n = Number(v) || 0;
      var fix = function (decimals, europe) {
        var parts = n.toFixed(decimals).split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, europe ? '.' : ',');
        return parts.join(europe ? ',' : '.');
      };
      return this.money.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
        if (k === 'amount_no_decimals') return fix(0, false);
        if (k === 'amount_with_comma_separator') return fix(2, true);
        if (k === 'amount_no_decimals_with_comma_separator') return fix(0, true);
        return fix(2, false);
      });
    }

    productHtml(p, q) {
      var price = Number(p.price_min || p.price);
      var compare = Number(p.compare_at_price_max || 0);
      var off = compare > price ? Math.round((1 - price / compare) * 100) : 0;
      var img = (p.featured_image && p.featured_image.url) || p.image;
      var tags = (p.tags || []).map(function (t) { return String(t).toLowerCase(); });
      var isRx = this.rxTag && tags.indexOf(this.rxTag) > -1;
      var initials = esc(String(p.title || '?').trim().slice(0, 2).toUpperCase());
      return '<li><a class="tbs-product" href="' + esc(p.url) + '">' +
        '<span class="tbs-thumb">' + (img ? '<img src="' + esc(img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=120') + '" alt="" loading="lazy" width="60" height="60">' : '<span class="tbs-thumb__ph">' + initials + '</span>') + '</span>' +
        '<span class="tbs-pinfo">' +
        (isRx ? '<span class="tbs-badge">Rx required</span>' : '') +
        (p.available === false ? '<span class="tbs-badge tbs-badge--out">Out of stock</span>' : '') +
        '<span class="tbs-ptitle">' + highlight(p.title, q, 'mark') + '</span>' +
        (p.vendor ? '<span class="tbs-pmeta">' + esc(p.vendor) + '</span>' : '') +
        '<span class="tbs-price"><strong>' + esc(this.formatMoney(price)) + '</strong>' +
        (off > 0 ? '<s>' + esc(this.formatMoney(compare)) + '</s><span class="tbs-off">' + off + '% off</span>' : '') +
        '</span></span>' + ICON_CHEV + '</a></li>';
    }

    renderResults(q, res) {
      var products = res.products || [];
      var queries = (res.queries || []).filter(function (x) { return x.text && x.text.toLowerCase() !== q.toLowerCase(); }).slice(0, 4);
      var cols = (res.collections || []).slice(0, 4);
      var searchUrl = this.root + 'search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
      var html = '';

      if (!products.length && !queries.length && !cols.length) {
        this.status.textContent = 'No results for ' + q;
        this.live.innerHTML = '<div class="tbs-block"><div class="tbs-empty"><strong>No results for “' + esc(q) + '”</strong>' +
          '<p>Check the spelling, try the salt name (e.g. paracetamol), or send us your prescription and we’ll find it for you.</p></div>' +
          this.helpHtml(q) + '</div>';
        return;
      }
      if (queries.length || cols.length) {
        html += '<div class="tbs-block"><ul class="tbs-suggest">';
        queries.forEach(function (x) {
          html += '<li><a href="' + esc(x.url) + '">' + ICON_SEARCH + '<span>' + highlight(x.text, q, 'mark') + '</span></a></li>';
        });
        cols.forEach(function (c) {
          html += '<li><a href="' + esc(c.url) + '">' + ICON_GRID + '<span>' + highlight(c.title, q, 'mark') + ' <small style="color:#4a6272">· Category</small></span></a></li>';
        });
        html += '</ul></div>';
      }
      if (products.length) {
        html += '<div class="tbs-block"><div class="tbs-head"><h2>Products</h2></div><ul class="tbs-products">' +
          products.map((p) => this.productHtml(p, q)).join('') + '</ul>' +
          '<a class="tbs-all" href="' + esc(searchUrl) + '">See all results for “' + esc(q) + '”</a></div>';
      }
      html += '<div class="tbs-block">' + this.helpHtml(q) + '</div>';
      this.live.innerHTML = html;
      this.status.textContent = products.length + ' products found';
    }

    helpHtml(q) {
      var rx = this.dataset.rxUrl;
      var wa = this.dataset.whatsapp;
      var waText = encodeURIComponent('Hi Taabib, I am looking for: ' + q);
      var out = '<div class="tbs-help">';
      if (rx) out += '<a class="tbs-help__rx" href="' + esc(rx) + '">Upload prescription</a>';
      if (wa) out += '<a class="tbs-help__wa" href="https://wa.me/' + esc(wa) + '?text=' + waText + '" target="_blank" rel="noopener">Ask a pharmacist on WhatsApp</a>';
      return out + '</div>';
    }

    renderSkeleton() {
      var row = '<div class="tbs-skel-row"><span class="tbs-skel" style="width:60px;height:60px;flex:none"></span><span style="flex:1;display:flex;flex-direction:column;gap:8px"><span class="tbs-skel" style="height:12px;width:85%"></span><span class="tbs-skel" style="height:12px;width:40%"></span></span></div>';
      this.live.innerHTML = '<div class="tbs-block" aria-hidden="true"><span class="tbs-skel" style="height:14px;width:120px;margin-bottom:14px"></span>' + row + row + row + row + '</div>';
      this.status.textContent = 'Searching…';
    }

    renderError(q) {
      this.status.textContent = 'Search is not available right now';
      this.live.innerHTML = '<div class="tbs-block"><div class="tbs-empty"><strong>Couldn’t load suggestions</strong><p>Press search to see all results.</p></div>' +
        '<a class="tbs-all" href="' + esc(this.root + 'search?q=' + encodeURIComponent(q)) + '">Search “' + esc(q) + '”</a></div>';
    }
  }

  window.customElements.define('taabib-search', TaabibSearch);
})();

/* Taabib: hide the mobile search row when scrolling down, show it again when scrolling up */
(function () {
  var rows = document.getElementsByClassName('header-row-search');
  var lastY = window.scrollY || 0, ticking = false, hidden = false, busyUntil = 0;
  function update() {
    ticking = false;
    var y = window.scrollY || 0;
    if (Date.now() < busyUntil) { lastY = y; return; }   // ignore the small jump while the row opens/closes
    if (Math.abs(y - lastY) < 12 && y > 80) return;
    var hide = y > 80 && y > lastY;
    lastY = y;
    if (hide === hidden) return;
    hidden = hide;
    busyUntil = Date.now() + 350;
    for (var i = 0; i < rows.length; i++) rows[i].classList.toggle('tbs-row-hidden', hide);
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; requestAnimationFrame(update); }
  }, { passive: true });
})();

/* Taabib: on phones, lift floating buttons (WhatsApp, back-to-top) above the bottom menu bar so they don't cover Cart */
(function () {
  var GAP = 12, SPACING = 10;
  function isFixed(el) { var p = getComputedStyle(el).position; return p === 'fixed' || p === 'sticky'; }
  function findBottomBar(vw, vh) {
    var best = null, all = document.body.getElementsByTagName('*');
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (el.closest('taabib-search, .tbs-panel')) continue;
      var r = el.getBoundingClientRect();
      if (r.width < vw * 0.9 || r.height < 36 || r.height > 120) continue;
      if (Math.abs(r.bottom - vh) > 4) continue;
      if (getComputedStyle(el).position !== 'fixed') continue;
      if (!best || r.height > best.getBoundingClientRect().height) best = el;
    }
    return best;
  }
  function arrange() {
    var vw = window.innerWidth, vh = window.innerHeight;
    if (vw >= 992) return;
    var bar = findBottomBar(vw, vh);
    if (!bar) return;
    var barH = Math.round(bar.getBoundingClientRect().height);
    var floats = [], all = document.body.getElementsByTagName('*');
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (el === bar || bar.contains(el) || el.contains(bar) || el.closest('taabib-search, .tbs-panel')) continue;
      if (getComputedStyle(el).position !== 'fixed') continue;
      if (el.parentElement && el.parentElement.closest && floatsHasAncestor(floats, el)) continue;
      var r = el.getBoundingClientRect();
      if (r.width === 0 || r.height === 0 || r.width > 140 || r.height > 140) continue;
      if (vw - r.right > 60 || vh - r.bottom > 320) continue;       // bottom-right corner only
      var wa = /wa\.me|whatsapp/i.test(el.outerHTML.slice(0, 3000));
      floats.push({ el: el, h: r.height, origBottom: el.dataset.tbsOrigBottom ? +el.dataset.tbsOrigBottom : vh - r.bottom, wa: wa });
    }
    if (!floats.length) return;
    // WhatsApp first (closest to the bar), then the rest in their original order.
    floats.sort(function (a, b) { return (b.wa - a.wa) || (a.origBottom - b.origBottom); });
    var y = barH + GAP;
    floats.forEach(function (f) {
      if (!f.el.dataset.tbsOrigBottom) f.el.dataset.tbsOrigBottom = String(Math.round(f.origBottom));
      f.el.style.setProperty('top', 'auto', 'important');
      f.el.style.setProperty('bottom', y + 'px', 'important');
      y += Math.round(f.h) + SPACING;
    });
  }
  function floatsHasAncestor(list, el) {
    for (var i = 0; i < list.length; i++) if (list[i].el.contains(el)) return true;
    return false;
  }
  var t;
  function soon() { clearTimeout(t); t = setTimeout(arrange, 250); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', soon); else soon();
  window.addEventListener('load', soon);
  window.addEventListener('resize', soon);
  window.addEventListener('scroll', soon, { passive: true });   // e.g. the back-to-top arrow appears after scrolling
  [1500, 4000, 8000].forEach(function (ms) { setTimeout(arrange, ms); });   // chat apps often load late
})();

/* Taabib: make the theme's product sliders on the home page move by themselves */
(function () {
  if (window.__taabibAutoSlide) return;
  window.__taabibAutoSlide = true;
  var EVERY = 3500, PAUSE_AFTER_TOUCH = 6000;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var SLIDERS = '.slick-initialized, .swiper-initialized, .swiper-container-initialized, .owl-carousel.owl-loaded, .flickity-enabled, .splide.is-initialized';
  var NEXT = '.slick-next, .swiper-button-next, .owl-next, .flickity-prev-next-button.next, .splide__arrow--next, [class*="arrow-next"], [class*="next-arrow"], button[aria-label*="Next" i]';
  var SKIP = 'taabib-search, taabib-slider, .th-hero, .tbs-panel';

  function productLinks(el) { return el.querySelectorAll('a[href*="/products/"]').length; }
  function isScroller(el) {
    var s = getComputedStyle(el);
    return (s.overflowX === 'auto' || s.overflowX === 'scroll') && el.scrollWidth > el.clientWidth + 20;
  }
  function visibleBtn(list) {
    for (var i = 0; i < list.length; i++) {
      var b = list[i];
      if (b.offsetParent !== null && !b.disabled && !/disabled/.test(b.className)) return b;
    }
    return null;
  }
  // Move a slider library one step, using its own controls where possible.
  function nextSlide(el, root) {
    var $ = window.jQuery;
    if (el.classList.contains('slick-initialized') && $ && $.fn.slick) { $(el).slick('slickNext'); return; }
    if (el.swiper) { el.swiper.slideNext(); if (el.swiper.isEnd && !el.swiper.params.loop) setTimeout(function () { el.swiper.slideTo(0); }, EVERY - 400); return; }
    if (el.classList.contains('owl-carousel') && $) { $(el).trigger('next.owl.carousel'); return; }
    if (window.Flickity && window.Flickity.data && window.Flickity.data(el)) { window.Flickity.data(el).next(true); return; }
    var btn = visibleBtn(root.querySelectorAll(NEXT));
    if (btn) { btn.click(); return; }
    var dot = root.querySelector('.slick-dots button, .swiper-pagination-bullet, .owl-dot, .flickity-page-dots .dot');
    if (dot) dot.click();
  }

  function setup(root, step) {
    var paused = 0, visible = true;
    ['pointerdown', 'touchstart', 'mouseenter', 'focusin', 'wheel'].forEach(function (ev) {
      root.addEventListener(ev, function () { paused = Date.now() + PAUSE_AFTER_TOUCH; }, { passive: true });
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { visible = es[0].isIntersecting; }, { threshold: 0.3 }).observe(root);
    }
    setInterval(function () {
      if (document.hidden || !visible || Date.now() < paused) return;
      step();
    }, EVERY);
  }

  var done = [];
  function start() {
    var seen = function (el) { return done.some(function (d) { return d === el || d.contains(el) || el.contains(d); }); };

    // 0) This theme's own slider ("slide_ui"): press its next button, even when the arrows are hidden on phones
    document.querySelectorAll('.slide_ui-element').forEach(function (el) {
      if (seen(el) || el.closest(SKIP)) return;
      var root = el.closest('.section_content-body') || el.parentElement;
      var next = root.querySelector('.slide_ui-btn-next');
      var prev = root.querySelector('.slide_ui-btn-prev');
      if (!next) return;
      done.push(root);
      var where = function () { var f = el.querySelector('.product-section') || el.firstElementChild; return f ? Math.round(f.getBoundingClientRect().left) + '|' + el.scrollLeft : el.scrollLeft; };
      setup(root, function () {
        var before = where();
        next.click();
        setTimeout(function () {
          if (where() !== before) return;            // it moved
          // Reached the end: go back to the first product
          if (el.scrollLeft > 0) { el.scrollTo({ left: 0, behavior: 'smooth' }); return; }
          if (!prev) return;
          var n = el.querySelectorAll('.product-section').length || 10, k = 0;
          var back = setInterval(function () { prev.click(); if (++k >= n) clearInterval(back); }, 80);
        }, 700);
      });
    });

    // 1) Slider libraries (Slick, Swiper, Owl, Flickity, Splide), even when their arrows are hidden on phones
    document.querySelectorAll(SLIDERS).forEach(function (el) {
      if (seen(el) || el.closest(SKIP) || productLinks(el) < 2) return;
      done.push(el);
      var root = el.closest('section, .shopify-section') || el.parentElement;
      setup(el, function () { nextSlide(el, root); });
    });
    // 2) Other sliders that only have a "next" arrow
    document.querySelectorAll(NEXT).forEach(function (btn) {
      var root = btn.closest('section, .shopify-section') || btn.parentElement;
      if (!root || seen(root) || root.closest(SKIP) || productLinks(root) < 2) return;
      done.push(root);
      setup(root, function () { nextSlide(root, root); });
    });
    // 3) Rows that scroll sideways (common on phones)
    document.querySelectorAll('body *').forEach(function (el) {
      if (seen(el) || el.closest(SKIP)) return;
      if (!isScroller(el) || productLinks(el) < 2) return;
      done.push(el);
      setup(el, function () {
        var card = el.querySelector('a[href*="/products/"]');
        while (card && card.parentElement !== el && card.parentElement) card = card.parentElement;
        var w = (card && card.getBoundingClientRect().width) || el.clientWidth * 0.5;
        if (el.scrollLeft + el.clientWidth >= el.scrollWidth - 8) el.scrollTo({ left: 0, behavior: 'smooth' });
        else el.scrollBy({ left: Math.round(w), behavior: 'smooth' });
      });
    });
  }

  // Theme sliders are often built (or loaded) a moment after the page loads, so look a few times.
  function later() { [800, 2500, 5000, 9000].forEach(function (ms) { setTimeout(start, ms); }); }
  if (document.readyState === 'complete') later(); else window.addEventListener('load', later);
})();